import { ExpandLess, ExpandMore } from '@mui/icons-material';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { Collapse, ListItemButton } from '@mui/material';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useKeycloak } from '@react-keycloak/web';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { navigation } from './navigation';

const NavList = (): JSX.Element => {
  const [openSubmenu, setOpenSubmenu] = useState<{ [key: string]: boolean }>(
    {}
  );
  const navigate = useNavigate();
  const location = useLocation();
  const { keycloak } = useKeycloak();

  useEffect(() => {
    const navigationChild = navigation.filter((item) => item.child);
    navigationChild.forEach((nav) => {
      const childRoutes = nav.child?.map((child) => child.route);
      if (childRoutes && childRoutes.includes(location.pathname)) {
        setOpenSubmenu({ [nav.name]: true });
      }
    });
  }, [location]);

  const handleSubMenus = (name: string) => {
    setOpenSubmenu((state) => ({ [name]: !state[name] }));
  };

  const currentNavigation = () => {
    return navigation.filter((navItem) => {
      return navItem?.roles?.includes(keycloak.tokenParsed?.roles[0]);
    });
  };

  return (
    <List>
      {currentNavigation().map((navItem) => (
        <div key={navItem.id}>
          {navItem.child !== undefined ? (
            <div key={navItem.id}>
              <ListItemButton onClick={() => handleSubMenus(navItem.name)}>
                <ListItemIcon sx={{ minWidth: '40px' }}>
                  {navItem.icon}
                </ListItemIcon>
                <ListItemText primary={navItem.name} />
                {openSubmenu[navItem.name] ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>

              <Collapse
                in={openSubmenu[navItem.name]}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  {navItem.child.map((child) => {
                    return (
                      child?.roles?.includes(
                        keycloak.tokenParsed?.roles[0]
                      ) && (
                        <ListItemButton
                          sx={{
                            bgcolor:
                              location.pathname === child.route ? '#F6F7FB' : ''
                          }}
                          key={child.id}
                          onClick={() => navigate(child.route)}
                        >
                          <Box pl={5}>
                            <ListItemText primary={child.name} />
                          </Box>
                        </ListItemButton>
                      )
                    );
                  })}
                </List>
              </Collapse>
            </div>
          ) : (
            <ListItemButton
              sx={{
                bgcolor: location.pathname === navItem.route ? '#F6F7FB' : ''
              }}
              key={navItem.id}
              onClick={() => navigate(navItem.route)}
            >
              <ListItemIcon sx={{ minWidth: '40px' }}>
                {navItem.icon}
              </ListItemIcon>
              <ListItemText primary={navItem.name} />
            </ListItemButton>
          )}
        </div>
      ))}
      <ListItemButton onClick={() => keycloak.logout()}>
        <ListItemIcon sx={{ minWidth: '40px' }}>
          <PowerSettingsNewIcon />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </ListItemButton>
    </List>
  );
};

export default NavList;
